import register from "preact-custom-element";
import Collection from "./components/Collection";

register(Collection, "uwp-collection", ["collection-handle"]);
